import { Component } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'service-unavailable',
  imports: [ButtonDirective, RouterLink],
  templateUrl: './service-unavailable.component.html',
  styleUrl: './service-unavailable.component.scss',
})
export class ServiceUnavailableComponent {}
